<template>
  <div>

    <div class="d-flex justify-end">
      <memlist-icon-button
        class="mb-2"
        icon="menu-icon flaticon2-plus"
        :text="$t('PARENT.CREATE')"
        variant="primary"
        @click="$emit('create')"
      />
    </div>

    <memlist-static-table
      id="parents-table" 
      :fields="fields" 
      :items="items" 
      ref="parents-table">
      <template #cell(action)="data">
        <div class="text-right" v-if="!view_only">
          <memlist-table-button class="mr-3" @click="edit_row_clicked(data.item)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')" />
          <memlist-table-button class="mr-3" @click="delete_row_clicked(data.item)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')" />
        </div>
      </template>
    </memlist-static-table>

    </div>

</template>


<script>

import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { is_mobile } from '@/core/services/utils';

export default {

  name: 'MemberParentTable',

  props: ['member', 'items', 'company'],
  emits: ['select', 'delete', 'create'],

  mixins: [toasts],

  components: {

  },

  watch: {

  },

  computed: {
    is_mobile() {
      return is_mobile();
    },
  },

  methods: {

    async edit_row_clicked(item) {

      this.$nextTick(() => {
        this.$emit('select', item);
      });
    },

    async delete_row_clicked(item) {
      this.$emit('delete', item);
    },

  },

  mounted() {

    if (this.is_mobile) {
      this.fields = this.fields.filter((field) => {
        return field.mobile;
      });
    }
  },

  data() {
    return {

      fields: [
        {
          key: 'firstname',
          label: this.$t('MEMBER.FIRSTNAME'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short4',
          thClass: 'td-short4'
        },
        {
          key: 'lastname',
          label: this.$t('MEMBER.LASTNAME'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short4',
          thClass: 'td-short4'
        },
        {
          key: 'email',
          label: this.$t('MEMBER.EMAIL'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short4',
          thClass: 'td-short4'
        },
        {
          key: 'phone',
          label: this.$t('MEMBER.PHONE'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short4',
          thClass: 'td-short4'
        },

        {
          key: 'action',
          label: '',
          tdClass: 'td-short3',
          thClass: 'td-short3',
          sortable: false
        }
      ],

      show_form: true,

    };
  }
};

</script>
<style lang="scss" scoped>
  
  
</style>
